import styled from 'styled-components';

const TagResources = styled.div`
  background-color: #212b65;
  color: #c0c4ec;
  width: fit-content;
  padding: 1px 10px;
  border-radius: 4px;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.div`
  color: #161d1f;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;

const DivBox = styled.div`
  color: #161d1f;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  margin: 16px 0px;
  width: 100%;
  background: #f7fafb;
  border: 1px solid var(--card-focus);
  border-radius: 8px;

  ul {
    list-style-type: disc;
    padding-left: 25px;
  }
`;

const TitleBox = styled.div`
  color: #161d1f;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
`;

const SpanGrayBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-text01);
  span {
    color: var(--text-text02);
    font-weight: 700;
  }
`;

// const LineBox = styled.div`
//     div {
//         width: 100%;
//         text-align: center;
//         border-bottom: 1px solid #bfd8e9;
//         line-height: 0.1em;
//         margin: 24px 0px;
//         // padding: 20px 0px 0px 0px;
//     }

//     div span {
//         // background:#fff;
//         padding:0 10px;
//     }
// `;

const Separator = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  background: #fff;

  ::before,
  ::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #bfd8e9;
  }

  :not(:empty)::before {
    margin-right: 8px;
  }

  :not(:empty)::after {
    margin-left: 8px;
  }
`;

export { TagResources, Title, DivBox, TitleBox, SpanGrayBox, Separator };
